export default "__VITE_ASSET__BZGl4i68__"